import blog1 from "../img/blogs/blog1.svg";
import blog2 from "../img/blogs/blog2.svg";
import blog3 from "../img/blogs/blog3.svg";
import blog4 from "../img/blogs/blog4.svg";
import blog5 from "../img/blogs/blog5.svg";

const blogs = [
  {
    id: 1,
    image: blog1,
    title: "Career Change into Tech",
    link: "https://dev.to/cod3rcarl/career-change-into-tech-5he5",
    date: "21",
    month: "September",
    year: "2020",
  },
  {
    id: 2,
    image: blog2,
    title: "My First React Custom Hook",
    link: "https://dev.to/cod3rcarl/my-first-react-custom-hook-2e23",
    date: "24",
    month: "November",
    year: "2020",
  },
  {
    id: 3,
    image: blog3,
    title: "Map, Filter, Reduce",
    link: "https://dev.to/cod3rcarl/map-filter-reduce-177n",
    date: "3",
    month: "December",
    year: "2020",
  },
  {
    id: 4,
    image: blog4,
    title: "School of Code Demo Day - EngageMate",
    link: "https://www.youtube.com/watch?v=p23oB7cUReQ&t=2s",
    date: "16",
    month: "January",
    year: "2021",
  },
  {
    id: 5,
    image: blog5,
    title: "The Recipe Room Demo",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:6772954921491865602",
    date: "03",
    month: "March",
    year: "2021",
  },
];

export default blogs;
